import { render, staticRenderFns } from "./modalAtualizaPrecos.vue?vue&type=template&id=030af6db&"
import script from "./modalAtualizaPrecos.vue?vue&type=script&lang=js&"
export * from "./modalAtualizaPrecos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports